import classNames from "classnames";
import { Form, Formik } from "formik";
import { FC } from "react";
import { object, string } from "zod";
import { toFormikValidationSchema } from "zod-formik-adapter";

import { Button, Typography } from "@/shared/ui";
import { useOnboardingStore } from "@/stores";

import styles from "./description.module.scss";
import { DescriptionTabFormScheme } from "./description.types";

const validationScheme = object({
  introduction: string().min(1, "Field is required").max(1000, "Must be at most 1000 characters"),
});

const DescriptionTab: FC = () => {
  const currentStep = useOnboardingStore((state) => state.currentStep);
  const { setCurrentStep, setInfo, addPassedStep } = useOnboardingStore((state) => state.actions);

  const introduction = useOnboardingStore((state) => state.userInfo.introduction);

  const onSubmitHandler = (data: DescriptionTabFormScheme) => {
    setInfo(data);
    setCurrentStep(currentStep + 1);
    addPassedStep(currentStep);
  };

  return (
    <main className={styles.descriptionTab}>
      <Typography semi variant="title-2">
        Introduce yourself
      </Typography>

      <Formik<DescriptionTabFormScheme>
        initialValues={{ introduction: introduction ?? "" }}
        validationSchema={toFormikValidationSchema(validationScheme)}
        validateOnBlur={false}
        validateOnChange={false}
        onSubmit={onSubmitHandler}
      >
        {({ values, errors, isValid, setFieldValue, validateField }) => (
          <Form className={styles.form}>
            <div className={styles.inputContainer}>
              <textarea
                placeholder="What should people know about you"
                className={classNames(styles.input, errors.introduction && styles.withError)}
                value={values.introduction}
                onChange={async ({ target: { value } }) => {
                  await setFieldValue("introduction", value);
                  await validateField("introduction");
                }}
              />
              {errors.introduction && (
                <Typography className={styles.errorText} variant="caption-2">
                  {errors.introduction}
                </Typography>
              )}
            </div>

            <Button fullWidth size="big" type="submit" disabled={!isValid || !values.introduction}>
              Continue
            </Button>
          </Form>
        )}
      </Formik>
    </main>
  );
};

export { DescriptionTab };
